// This file handles the resolution center labels based on the Elmo treatment

import i18n from './reacti18n';
import { elmoTreatmentNames, isPartOfElmoExpTreatment } from './experiments-helper';
import Page from './page';

const resCenterMessages = {
  disputes: i18n.message('smarthelp/contactLinksOption.messageLabel.resolution.disputes'),
  cases: i18n.message('smarthelp/contactLinksOption.messageLabel.resolution.cases'),
  issues: i18n.message('smarthelp/contactLinksOption.messageLabel.resolution.issues'),
  refund: i18n.message('smarthelp/contactLinksOption.messageLabel.resolution.refund'),
  resolution: i18n.message('smarthelp/contactLinksOption.message.resolution'),
};

const resolutionCenterLabels = () => {
  // Elmo Treatments created for resolution center labels
  const disputeLabel = elmoTreatmentNames.resCenterDisputesLabel;
  const casesLabel = elmoTreatmentNames.resCenterCasesLabel;
  const issuesLabel = elmoTreatmentNames.resCenterIssuesLabel;
  const refundLabel = elmoTreatmentNames.resCenterRefundLabel;

  const elmoTreatments = Page.elmoTreatments();

  /**
   * Checking whether if any of the resolution center elmo treatments exists
   */

  if (isPartOfElmoExpTreatment(elmoTreatments, disputeLabel)) {
    return resCenterMessages.disputes;
  } if (isPartOfElmoExpTreatment(elmoTreatments, casesLabel)) {
    return resCenterMessages.cases;
  } if (isPartOfElmoExpTreatment(elmoTreatments, issuesLabel)) {
    return resCenterMessages.issues;
  } if (isPartOfElmoExpTreatment(elmoTreatments, refundLabel)) {
    return resCenterMessages.refund;
  }
  // if any of the resolution center elmo treatments doesn't exist display the existing label
  return resCenterMessages.resolution;
};

export default resolutionCenterLabels;
